// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Xlfm","content":"styles_content__1jvZj","selectAll":"styles_selectAll__26m3K"};